/**
 * URLs de assets estáticos em `public/` (funcionam em dev e produção).
 * Nunca use `/src/assets/...` em runtime — esse caminho não existe no build.
 */
function publicAssetUrl(path) {
    const p = path.startsWith('/') ? path : `/${path}`;
    const base = import.meta.env.BASE_URL || '/';
    if (base === '/') return p;
    const baseTrimmed = base.replace(/\/$/, '');
    return `${baseTrimmed}${p}`;
}

export const DEFAULT_COURSE_IMAGE_URL = publicAssetUrl('/assets/images/course-placeholder.svg');
export const DEFAULT_USER_AVATAR_URL = publicAssetUrl('/assets/images/user-placeholder.svg');

/**
 * Evita loop infinito em @error: aplica fallback uma vez e remove o handler.
 * @param {Event} event
 * @param {string} fallbackUrl
 */
export function applyImageFallbackOnce(event, fallbackUrl) {
    const img = event?.target;
    if (!img || img.tagName !== 'IMG') return;

    if (img.dataset.imgFallbackApplied === '1') {
        img.onerror = null;
        return;
    }

    img.dataset.imgFallbackApplied = '1';
    img.onerror = null;
    img.removeAttribute('srcset');
    img.src = fallbackUrl;

    // Capa de curso: cards usam object-fit:cover + área larga/baixa — SVG quadrado era cortado
    if (typeof fallbackUrl === 'string' && fallbackUrl.includes('course-placeholder')) {
        img.classList.add('course-img-placeholder');
    }
}
